var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTiktok = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { fill: "currentColor", d: "M15.581 5.254c-.855 0-1.65-.285-2.283-.761A3.78 3.78 0 0 1 11.785 1.5H9.337v10.358a2.222 2.222 0 0 1-3.363 1.9 2.21 2.21 0 0 1-1.084-1.867 2.22 2.22 0 0 1 2.917-2.137V7.27a5 5 0 0 0-.707-.05 4.7 4.7 0 0 0-3.53 1.577 4.6 4.6 0 0 0 .652 6.732 4.7 4.7 0 0 0 2.877.975 4.7 4.7 0 0 0 3.322-1.361 4.6 4.6 0 0 0 1.377-3.263l-.012-5.475c.42.326.882.592 1.377.802a6.2 6.2 0 0 0 2.418.488V5.258h-.007z" }) }))); };
export default SvgTiktok;
